import { render, staticRenderFns } from "./fact_summary.vue?vue&type=template&id=4c9128a7&"
import script from "./fact_summary.vue?vue&type=script&lang=ts&"
export * from "./fact_summary.vue?vue&type=script&lang=ts&"
import style0 from "./fact_summary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VLayout})
